// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label p[data-v-cf6ae228] {\n  margin-bottom: 0;\n}\nlabel .caption[data-v-cf6ae228] {\n  font-size: 1.2rem;\n}\nlabel .description[data-v-cf6ae228] {\n  margin-left: 1.5rem;\n}", ""]);
// Exports
module.exports = exports;
